import { useTheme } from 'styled-components';
import BoxContainer from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXIcon from '../../core/components/buttons/lxIcon';
import { LXbody, LXCaption, LXh1, LXh4 } from '../../core/texts/lxText';
import { ReactComponent as TestCompletedIcon } from '../../../assets/icons/testCompleted.svg';
import FlexBox from '../../core/components/box/flexBox';
import { Divider } from '../../setting/noticeDetailPage';
import { TestStatusDto, TestSummary } from '../../../2_domain/test/test';
import LXSpinner from '../../core/spinner/lx_spinner';
import { Empty } from 'antd';
import useTestDoneBoardControl from '../../../1_application/dashboard/testBoardController';

interface TestCompletedPropsType {
  width?: string;
  height?: string;
  fromDate?: Date;
  endDate?: Date;
  statusDone: TestStatusDto;
}

const TestCompleted = ({
  width,
  height,
  fromDate,
  endDate,
  statusDone,
}: TestCompletedPropsType) => {
  const theme = useTheme();

  const t = useTestDoneBoardControl(fromDate, endDate, statusDone);

  const makeList = (tests: TestSummary[]) => {
    if (tests.length === 0) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }
    return tests.map((test) => {
      return (
        <Row
          key={test.id}
          onClick={t.navigateToTestId(test.id)}
          padding="20px 0 0 10px"
        >
          <LXbody width="104px">{test.serial}</LXbody>
          <SizedBox width={16} />
          <LXbody>{test.name}</LXbody>
          <SizedBox width={2} />
          {test.numberOfItems && (
            <LXCaption>{`+${test.numberOfItems - 1}`}</LXCaption>
          )}
          <FlexBox></FlexBox>
          <LXbody width="152px">{test.clientName}</LXbody>
        </Row>
      );
    });
  };

  if (t.loading)
    return (
      <BoxContainer width={width} height={height}>
        <LXSpinner></LXSpinner>
      </BoxContainer>
    );
  return (
    <BoxContainer height={height} width={width} padding="24px 30px 30px 30px">
      <Column>
        <Row justifyContent="space-between" alignItems="center">
          <LXh4>{theme.texts.TestCompleted}</LXh4>
          <LXCaption
            onClick={t.navigateToTestList}
            color={theme.colors.primary500}
          >
            {theme.texts.seeAll}
          </LXCaption>
        </Row>
        <SizedBox height={24}></SizedBox>
        <Row alignItems="center">
          <LXIcon
            width="48px"
            icon={TestCompletedIcon}
            backgroundColor={theme.colors.grayIconBg}
          ></LXIcon>
          <SizedBox width={16}></SizedBox>
          <LXh1 height="32px" textAlign="center">
            {t.testSummary.page?.totalElements ?? 0}
          </LXh1>
        </Row>
        <SizedBox height={33}></SizedBox>
        <Row padding="0 0 12px 10px">
          <LXCaption width="104px">{theme.texts.testNo}</LXCaption>
          <SizedBox width={16} />
          <LXCaption>{theme.texts.testName}</LXCaption>
          <FlexBox></FlexBox>
          <LXCaption width="152px">{theme.texts.client}</LXCaption>
        </Row>
        <Divider></Divider>
        {makeList(t.testSummary.list)}
      </Column>
    </BoxContainer>
  );
};

export default TestCompleted;
